import { useState } from 'react'
import { Checkbox, Modal } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'

import Box from '~/core/Box'
import Button from '~/core/Button'
import Link from '~/core/Link'
import Text from '~/core/Text'
import { setLocalStorageItem } from '../HTS/HTSLogic'
import { DONOT_SHOW_UPDATED_TERM_MODAL } from '../constants'

import {
    UPDATED_HTS_TERM_TITLE,
    BORDER,
    INTERNATIONAL_SHIPPING_REQUIREMENT,
} from './constants'
import styles from './styles.css'

const PLACEMENT = 'updated-hts-term-modal'
const BUTTON_NAME = 'understand-terms'

type UpdatedHTSTermModalPropsType = {
    visible: boolean
    onClose: () => void
    setUnderstandTerms: (understand: boolean) => void
}

const UpdatedHTSTermModal = (props: UpdatedHTSTermModalPropsType) => {
    const { visible, onClose, setUnderstandTerms } = props
    const [doNotShow, setDoNotShow] = useState(false)

    const onCheckBoxChange = (evt: CheckboxChangeEvent) => {
        setDoNotShow(evt.target.checked)
    }

    const handleOnClick = () => {
        setLocalStorageItem(DONOT_SHOW_UPDATED_TERM_MODAL, doNotShow)
        setUnderstandTerms(true)
        onClose()
    }

    return (
        <Modal
            bodyStyle={{ padding: 0 }}
            className={styles.htsModal}
            closable={false}
            footer={null}
            title={UPDATED_HTS_TERM_TITLE}
            visible={visible}
        >
            <Box direction="col" padding="16px">
                <Text>
                    All overseas orders will now{' '}
                    <Text fontWeight="bold">
                        require the completion of the customs information on
                        this page within 48 hours of purchase
                    </Text>
                    . Failure to complete this form may result in shipping
                    delays and impact the estimated delivery of your parts.
                </Text>
                <Text style={{ marginTop: '8px' }}>
                    Additionally, please note that for orders where (a) the
                    parts do not meet the prototype requirements, or (b) where
                    you do not provide a DETAILED description of the part,
                    parent product, AND end-use, you will be required to act as
                    the <Text fontWeight="bold">Importer of Record</Text> and
                    you may be assessed duties upon import. Reference{' '}
                    <Link
                        data-name="international-shipping-requirement-link"
                        href={INTERNATIONAL_SHIPPING_REQUIREMENT}
                        placement={PLACEMENT}
                        target="_blank"
                    >
                        this article
                    </Link>{' '}
                    for more info.
                </Text>
            </Box>
            <Box
                alignItems="center"
                borderTop={BORDER}
                justifyContent="between"
                padding="10px 16px"
            >
                <Checkbox onChange={onCheckBoxChange}>
                    Don’t show again
                </Checkbox>
                <Button
                    data-name={BUTTON_NAME}
                    data-test-target={`${BUTTON_NAME}-${PLACEMENT}`}
                    placement={PLACEMENT}
                    onClick={handleOnClick}
                    type="primary"
                >
                    I understand the terms
                </Button>
            </Box>
        </Modal>
    )
}

export default UpdatedHTSTermModal
